import React, { Component } from "react";
import "./DeconstructedUpper.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import classNames from "classnames";
import deconstructed from "../../../assets/images/deconstructed.png";

class DeconstructedUpper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      translateXValue: 0,
      currentImageStep: 0,
      containerWidth: 0,
      activeYear: '2018',
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    const { data } = this.props;
    if (data.photos[this.state.activeYear]) {
      const numberOfLandscapeImages = document.querySelectorAll(
        ".SingleCollection-image--ls"
      ).length;

      this.setState({
        numberOfLandscapeImages,
        containerWidth: data.photos[this.state.activeYear].length * 50 + numberOfLandscapeImages * 50
      });
    }
    window.addEventListener('touchstart', this.touchStart);
    window.addEventListener('touchmove', this.preventTouch, {passive: false});

    document.addEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e) {
    const LEFT_ARROW = e.keyCode === 37;
    const RIGHT_ARROW = e.keyCode === 39;
    if (LEFT_ARROW) {
      this.switchImages("prev");
    } else if (RIGHT_ARROW) {
      this.switchImages("next");
    }
  }

  handleYearChange() {
    const { data } = this.props;
    const numberOfLandscapeImages = document.querySelectorAll(
      ".SingleCollection-image--ls"
    ).length;
    this.setState({
      containerWidth: data.photos[this.state.activeYear].length * 50 + numberOfLandscapeImages * 50
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeYear !== this.state.activeYear) {
      this.handleYearChange();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener('touchstart', this.touchStart);
    window.removeEventListener('touchmove', this.preventTouch, {passive: false});
  }

  switchImages(direction) {
    const { currentImageStep, containerWidth } = this.state;
    const maxSteps = Math.floor(containerWidth / 110);
    if (direction === "next") {
      this.setState({
        currentImageStep:
          currentImageStep === maxSteps ? 0 : currentImageStep + 1
      });
    } else {
      this.setState({
        currentImageStep:
          currentImageStep === 0 ? maxSteps : currentImageStep - 1
      });
    }
  }

  handleDropdownChange(event) {
    this.setState({
      activeYear: event.target.value,
      currentImageStep: 0
    })
  }

  handleTouchStart(event) {
    this.x = event.touches[0].clientX;
    this.y = event.touches[0].clientY;
  }

  handleTouchMove(event) {
    this.xM = event.changedTouches[0].clientX;
    this.yM = event.changedTouches[0].clientY;
    const xDiff = this.xM - this.x;
    const yDiff = this.yM - this.y;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        this.switchImages("prev");
      } else {
        this.switchImages("next");
      }
    }
    this.x = null;
    this.y = null;
  }

  preventTouch(event){
    const minValue = 5; // threshold

    this.clientX = event.touches[0].clientX - this.firstClientX;
    this.clientY = event.touches[0].clientY - this.firstClientY;

    // Vertical scrolling does not work when you start swiping horizontally.
    if(Math.abs(this.clientX) > minValue){ 
        event.preventDefault();
        event.returnValue = false;
        return false;
    }
}

  render() {
    const { containerWidth, currentImageStep } = this.state;
    const translateXValue = (100 / (containerWidth / 100)) * currentImageStep;
    const { data, language } = this.props;
    return (
      <div className="DeconstructedUpper">
        <div className="DeconstructedUpperFB">
          <div className="DeconstructedUpperFB-text">{data.text}</div>
          <div className="DeconstructedUpperFB-content">
            <div className="DeconstructedLatestFSBorder" />
            <img
              className="DeconstructedTitleLogo"
              src={deconstructed}
              alt="deconstructed"
            />
            <span className="DeconstructedLatestSubTitle">{data.subtitle}</span>
          </div>
          <div className="BackgroundDeconstructed" />
          <div
            className="DeconstructedUpperFB-image"
            style={{ backgroundImage: `url(${data.photo})` }}
          />
        </div>
        <div className="DeconstructedVideo">
          <div className="DeconstructedVideo-Video">
            <video
              width="100%"
              src={data.video}
              autoPlay={true}
              controls={false}
              loop={true}
              muted={true}
            />
          </div>
        </div>
        <div className="DeconstructedWrapper">
          <div className="DeconstructedContent">
            <div>
              <span>{data.deconstructedGalleryTitle[language]}</span>
              <select onChange={ (event) => this.handleDropdownChange(event) } value={ this.state.activeYear } autoComplete="off" selected="selected" >
              {
                Object.keys(data.photos).map(year => {
                  return (
                    <option key={ year } selected="selected">{ year }</option>
                  )
                })
              }
              </select>
            </div>
            <p className="DeconstructedDescription">
              {data.description[language]}
            </p>
          </div>
          <div
            className="ImagesWrapper"
            onTouchStart={event => this.handleTouchStart(event)}
            onTouchEnd={event => this.handleTouchMove(event)}
          >
          <div className="MobileButtons">
          <button
            onClick={() => this.switchImages("prev")}
            className="SingleCollection-ButtonM"
          >
            <svg
              className="SvgPrev"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
            </svg>
          </button>
          <button
            onClick={() => this.switchImages("next")}
            className="SingleCollection-ButtonM ButtonM"
          >
            <svg
              className="SvgNext"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" />
            </svg>
          </button>
        </div>
            <button
              onClick={() => this.switchImages("prev")}
              className="SingleCollection-Button"
            >
              <div className="Button-div">
                <svg
                  className="SvgPrev"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
                </svg>
              </div>
            </button>
            <div className="SingleCollection-RelativeDiv">
              <div
                className="SingleCollection-images"
                style={{
                  width: `${containerWidth}%`,
                  transform: `translateX(-${translateXValue}%)`
                }}
              >
                {data.photos[this.state.activeYear].map((item, index) => {
                  const imageClasses = classNames(
                    "SingleCollection-image",
                    item.orientation === "landscape" &&
                      "SingleCollection-image--ls"
                  );
                  return (
                    <div
                      className={imageClasses}
                      key={index}
                      style={{ backgroundImage: `url(${item.image})` }}
                    />
                  );
                })}
              </div>
            </div>
            <button
              onClick={() => this.switchImages("next")}
              className="SingleCollection-Button"
            >
              <div className="Button-div">
                <svg
                  className="SvgNext"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" />
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(DeconstructedUpper));



// WEBPACK FOOTER //
// ./src/components/Deconstructed/DeconstructedUpper/index.js